// components/AuthWrapper.js
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const AuthWrapper = ({ children }) => {
  const location = useLocation();
  const isSignIn = location.pathname === '/signin';

  return (
    <div style={{
      minHeight: 'calc(100vh - 80px)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #E8F8F2 0%, #D1FAE5 100%)',
      padding: '20px',
    }}>
      <div style={{
        backgroundColor: '#ffffff',
        borderRadius: 16,
        padding: 0,
        maxWidth: 440,
        width: '100%',
        boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
        overflow: 'hidden',
      }}>
        {/* Two Tab Buttons at Top */}
        <div style={{
          padding: '28px 32px 0',
        }}>
          <div style={{
            display: 'flex',
            gap: 4,
            background: '#F3F4F6',
            padding: 4,
            borderRadius: 10,
          }}>
            <Link to="/signin" style={{
              flex: 1,
              padding: '10px 16px',
              border: 'none',
              borderRadius: 8,
              fontSize: 14,
              fontWeight: 600,
              background: isSignIn ? '#ffffff' : 'transparent',
              color: isSignIn ? '#085041' : '#6B7280',
              boxShadow: isSignIn ? '0 2px 8px rgba(0,0,0,0.08)' : 'none',
              cursor: 'pointer',
              transition: 'all 0.2s',
              textDecoration: 'none',
              textAlign: 'center',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 8,
            }}>
              <i className="ti ti-login" aria-hidden="true" />
              Sign In
            </Link>
            <Link to="/signup" style={{
              flex: 1,
              padding: '10px 16px',
              border: 'none',
              borderRadius: 8,
              fontSize: 14,
              fontWeight: 600,
              background: !isSignIn ? '#ffffff' : 'transparent',
              color: !isSignIn ? '#085041' : '#6B7280',
              boxShadow: !isSignIn ? '0 2px 8px rgba(0,0,0,0.08)' : 'none',
              cursor: 'pointer',
              transition: 'all 0.2s',
              textDecoration: 'none',
              textAlign: 'center',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 8,
            }}>
              <i className="ti ti-user-plus" aria-hidden="true" />
              Sign Up
            </Link>
          </div>
        </div>

        {/* Content */}
        <div style={{ padding: '24px 32px 32px' }}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default AuthWrapper;